import { Component, OnInit, AfterViewInit } from '@angular/core';
import moment from 'moment';
import { User } from 'src/app/model/User';
import { LeavesService } from 'src/app/services/leaves.service';
import { LoaderService } from 'src/app/services/loader.service';
import { MobilityService } from 'src/app/services/mobility.service';

@Component({
  selector: 'app-mobilitybatch',
  templateUrl: './mobilitybatch.component.html',
  styleUrls: ['./mobilitybatch.component.css'],
})
export class MobilitybatchComponent implements OnInit, AfterViewInit {
  constructor(
    private mobilityService: MobilityService,
    private leavesService: LeavesService,
    private loader: LoaderService,
  ) {}

  enableUpdateButton: boolean = false;
  isYearButtonDisabled: boolean = true;
  message = false;
  messageDesc = '';
  user: User;
  selectedMonth: string;
  selectedYear: string;
  selectedFreezeMonth: Date;
  freezeTimeSheetDate: string;
  error = false;
  errorDesc = '';
  loading$: any;
  batchResult: any = null;

  ngOnInit(): void {}

  fetchExecutedBatches() {
    this.loader.show();
    this.mobilityService.fetchExecutedBatches(this.selectedMonth).subscribe(
      (res) => {
        console.log(res);
        this.loader.hide();
      },
      (err) => {
        console.error('Error fetching executed batches:', err);
        this.loader.hide();
      },
    );
  }
  ngAfterViewInit(): void {
    this.loading$ = this.loader.loading$;
  }

  fetchMobilityStatus(event) {
    this.loader.show();
    let selectedDate = moment(event.value).format('DD-MM-YYYY');
    this.freezeTimeSheetDate = selectedDate;
    this.error = false;
    this.leavesService
      .fetchYearBatchJobStatus('MONTHLY_MOBILITY', selectedDate)
      .subscribe(
        (res) => {
          console.log(res);
          this.batchResult = res;

          if (res.status == 'NOT_EXECUTED') {
            this.isYearButtonDisabled = false;
          } else {
            this.isYearButtonDisabled = true;
            this.error = true;
            this.errorDesc =
              res.batchJobName +
              ' Batch Job Already Executed for the Period ' +
              res.batchMonth +
              '-' +
              res.batchYear +
              ' On  ' +
              res.executionDate;
          }

          this.loader.hide();
        },
        (err) => {
          console.error('Error fetching batch job status:', err);
          this.batchResult = null;
          this.loader.hide();
        },
      );
  }

  updateMobilityForCurrentMonth() {
    // Logic to update mobility for the current month
    this.loader.show();
    console.log('Updating mobility for the current month...');
    const user = JSON.parse(
      localStorage.getItem('userDetails') || '{}',
    ) as User;
    this.mobilityService
      .batchUpdateMobilityForCurrentMonth(user.empId, this.selectedMonth)
      .subscribe(
        (response) => {
          console.log('Mobility updated successfully:', response);
          if (response.responseStatus === 'Success') {
            this.message = true;
            this.messageDesc = 'Mobility details updated successfully';
          } else if (response.responseStatus === 'Failed') {
            this.error = true;
            this.errorDesc = response.errorDescription;
          }
          this.loader.hide();
        },
        (error) => {
          console.error('Error updating mobility:', error);
          this.loader.hide();
        },
      );
    // You can add your actual implementation here
  }
}
